import { configureStore } from "@reduxjs/toolkit";
import tabReducer from "../features/TabSlice";
import droneReducer from "../features/DroneSlice";
import routeReducer from "../features/RouteSlice";
import farmReducer from "../features/FarmSlice";
import langReducer from "../features/LangSlice";
import { bindLangToStore } from "../i18n";

export const store = configureStore({
  reducer: {
    tab: tabReducer,
    drone: droneReducer,
    route: routeReducer,
    farm: farmReducer,
    lang: langReducer,
  },
});

// 언어 변경을 localStorage·<html lang>·훅 밖 t() 에 반영한다.
bindLangToStore(store);
